import { isFormEvent, compatibleLegaoSchema, getNodeSchemaById, isNodeSchema } from '@alilc/lowcode-utils';
export var utils = {
  isNodeSchema: isNodeSchema,
  isFormEvent: isFormEvent,
  compatibleLegaoSchema: compatibleLegaoSchema,
  getNodeSchemaById: getNodeSchemaById
};
export var EDITOR_EVENT = /*#__PURE__*/function (EDITOR_EVENT) {
  EDITOR_EVENT["NODE_CHILDREN_CHANGE"] = "node.children.change";
  EDITOR_EVENT["NODE_VISIBLE_CHANGE"] = "node.visible.change";
  return EDITOR_EVENT;
}({});